export default {
  name: 'vscroll',
  version: '1.6.3'
};
